import ENV from 'env.json';

interface sendDataToSSRType {
    loginDate: string;
    phoneNumber?: string;
    fullName?: string;
    expiresIn?: number;
}
export const _sendUserDataToLandingPage = (data: sendDataToSSRType | null) => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none'; // Hide the iframe
    iframe.src = `${ENV.landing}/auth`; // Endpoint to receive data on sipay.com
    document.body.appendChild(iframe);

    // Send the user data to the iframe using postMessage
    iframe.onload = () => {
        iframe.contentWindow?.postMessage(data, '*');
    };
};
